// http://mcg.mbitson.com/#!?primary=%232c6298
import { createTheme } from '@material-ui/core';

const primary = {
  50: '#e6ecf3',
  100: '#c0d0e0',
  200: '#96b1cc',
  300: '#6b91b7',
  400: '#4c7aa7',
  500: '#2c6298',
  600: '#275a90',
  700: '#215085',
  800: '#1b467b',
  900: '#10346a',
  A100: '#9fc2ff',
  A200: '#6ca1ff',
  A400: '#3981ff',
  A700: '#1f70ff',
};

// http://mcg.mbitson.com/#!?secondary=%23a5403e
const secondary = {
  50: '#f4e8e8',
  100: '#e4c6c5',
  200: '#d2a09f',
  300: '#c07978',
  400: '#b35d5b',
  500: '#a5403e',
  600: '#9d3a38',
  700: '#933230',
  800: '#8a2a28',
  900: '#791c1b',
  A100: '#ffb4b3',
  A200: '#ff8280',
  A400: '#ff4f4d',
  A700: '#ff3634',
};

const theme = createTheme({
  palette: {
    primary,
    secondary,
    error: secondary,
  },
  overrides: {
    MuiListItemText: {
      primary: {
        color: 'rgba(0, 0, 0, 0.87)',
      },
    },
    MuiTooltip: {
      popper: {
        zIndex: 1300,
      },
    },
  },
});

export default theme;
